<template>
  <div class="mod-config" style="height: 100%">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: left;" label="物联网卡号：">
        <el-input v-model="dataForm.msisdn" placeholder="请输入SIM卡号" clearable></el-input>
      </el-form-item>
      <el-form-item style="float: left;" label="设备名称：">
        <el-input v-model="dataForm.deviceName" placeholder="请输入设备名称" clearable></el-input>
      </el-form-item>
      <el-form-item style="float: left;" label="选择时间：">
        <el-date-picker
          v-model="dataForm.dateStr"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-button @click="search()" type="primary" icon="el-icon-search" style="float: left;"></el-button>
      <el-button size="mini" icon="el-icon-back" @click="returnd()" style="font-size: 22px;float: right"></el-button>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      style="width: 100%;" height="calc(100% - 120px)"
      border stripe :header-cell-style="{background:'#FAFAFA'}" placement="top"
    >
      <el-table-column
        prop="msisdn"
        header-align="center"
        align="center"
        label="卡号">
      </el-table-column>
      <el-table-column
        prop="deviceName"
        header-align="center"
        align="center"
        label="设备名称">
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        label="时间">
      </el-table-column>
      <el-table-column
        prop="content"
        header-align="center"
        align="center"
        label="内容">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>
<script>
import AddOrUpdate from './sim-add-or-update'
import {isAuth} from "@/utils";
export default {
  data() {
    return {
      dataForm: {
        params: '',
        dateStr: '',
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      addOrd:''
    }
  },
  components: {
    AddOrUpdate
  },
  created() {
    this.getDataList()
  },
  methods: {
    search(){
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      if (this.dataForm.dateStr) {
        this.dataForm.dateFromStr = this.dataForm.dateStr[0]
        this.dataForm.dateToStr = this.dataForm.dateStr[1]
      }
      if(this.dataForm.dateStr == null){
        this.dataForm.dateToStr = null
        this.dataForm.dateFromStr = null
      }
      this.$http({
        url: this.$http.adornUrl('/simAlert/record'),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
          'msisdn': this.dataForm.msisdn,
          'deviceName': this.dataForm.deviceName,
          'dateFromStr': this.dataForm.dateFromStr,
          'dateToStr': this.dataForm.dateToStr,
        })
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.dataList = data.data.rows
          this.totalPage = data.data.total
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg)
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    //
    query(id){
      this.$http({
        url: this.$http.adornUrl('sim/select/'+id),
        method: 'get',

      }).then(({data}) => {
        if (data && data.code === 200) {
          this.$message({
            message: data.msg,
            type: 'success',
            duration: 1000,
          })
          this.getDataList();
        } else {

        }
      })
    },
    //
    queryAll(){
      this.$http({
        url: this.$http.adornUrl('sim/getSimAll'),
        method: 'get',

      }).then(({data}) => {
        if (data && data.code === 200) {
          this.$message({
            message: data.msg,
            type: 'success',
            duration: 1000,
          })
          this.getDataList();
        } else {

        }
      })
    },
    //提醒记录
    reminderRecord(){

    },
    rechargeRecord(){

    },
    returnd() {
      this.$router.replace({path: '/indexhome/sim_management'});
    },
    // 权限
    isAuth(key) {
      return isAuth(key)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admincenter/reminderRecord.vue